import { gql } from '__generated__';

export default gql(`
  mutation SendImportConfirmations($id: ID!) {
    sendImportConfirmations(id: $id) {
      id
    }
  }
`);
